import React, { useContext, useEffect, useMemo, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { BsPlusCircle } from "react-icons/bs";

import { Button, Card, Grid, Group, SegmentedControl, Space, ThemeIcon, } from "@mantine/core";
import { useLocalStorage } from "@mantine/hooks";
// import KYCStatusFilter from "../../components/KYCStatusFilter";

import { Action, ActionType, BaseResult, CustomClaims, GenericProduct, Order, SubscriptionType, TypesenseOrder, } from "../../types";
import OrdersFirestoreSearch from "../../components/orders_firestore_search";
import OrdersInstantSearch from "../../components/orders_instant_search";
import { IconEye } from "@tabler/icons-react";
import GeneratePDFModal from "../../components/generate_pdf_modal";
import { ordersPath } from "../../helpers/orderFilesPath";
import GenerateCSVModal from "../../components/generate_csv_modal";
import { GlobalDataContext, MyUserDataContext } from "../../contexts";
import CustomListActionsModal from "../../components/custom_actions_modal";
import { httpsCallable } from "firebase/functions";
import { useFunctions } from "../../helpers/firebaseContext";
import { DocTypes } from "../../components/file_card";
import GenerateConfirmedOrdersCSVModal from "../../components/generate_confirmed_orders_csv_modal";
import RequestPaymentModal from "../../components/payment_collection_modal";
import PaymentReminderModal from "../../components/payment_reminder_modal";
import OpenEndedOrderPeriodSummary from "../../components/open_ended_order_period_summary";
import type { OrdersSummaryFilterRequest, OrdersSummaryFilterSelection } from "../../components/orders_instant_search";
import SendFundCertificate from "../../components/send_fund_certificate";



interface ActionsComponentProps {
  orderObj: Order;
}

type OrdersSearchBackend = "firestore" | "typesense";
const DEFAULT_ORDERS_SEARCH_BACKEND: OrdersSearchBackend =
  import.meta.env.VITE_ORDERS_SEARCH_BACKEND === "firestore" ? "firestore" : "typesense";


export const RenderActions = ({ orderObj }: ActionsComponentProps) => {
  // if (orderObj.created && !(orderObj.created instanceof Timestamp)) {
  //   orderObj.created = new Timestamp(orderObj.created as any, 0);
  // }


  const navigate = useNavigate();

  return <Group>


    <ThemeIcon color="blue" variant="light" onClick={() => {
      navigate("/orders/" + orderObj.id, { state: orderObj })
    }}><IconEye size={16} /></ThemeIcon>


  </Group>

}

const SubscriptionAndRedemptionList = () => {

  const userContext = useContext(MyUserDataContext);
  let userClaims = userContext.firebaseTokenResult?.claims.customClaims as CustomClaims || {};

  const functions = useFunctions();
  const globalDataContext = useContext(GlobalDataContext);
  const showOpenEndedOrderSummary = !userClaims.kfh_rm && !userClaims.kfh_oper;


  const [selectedRows, setSelectedRows] = useState<TypesenseOrder[]>([]);

  const [generatePDFOpen, setGeneratePDFOpen] = useState(false);
  const [generateCSVOpen, setGenerateCSVOpen] = useState(false);
  const [collectPaymentOpen, setCollectPaymentOpen] = useState(false);
  const [paymentReminderModalOpen, setPaymentReminderModalOpen] = useState(false);
  const [sendFundCertificateModalOpen, setSendFundCertificateModalOpen] = useState(false)
  const [orderActionsOpen, setOrderActionsOpen] = useState(false);
  const [summaryRefreshToken, setSummaryRefreshToken] = useState(0);
  const [ordersRefreshToken, setOrdersRefreshToken] = useState(0);
  const [summaryFilterRequest, setSummaryFilterRequest] = useState<OrdersSummaryFilterRequest | null>(null);
  const [ordersSearchBackend, setOrdersSearchBackend] = useLocalStorage<OrdersSearchBackend>({
    key: "orders-search-backend",
    defaultValue: DEFAULT_ORDERS_SEARCH_BACKEND,
    getInitialValueInEffect: false,
  });


  const navigate = useNavigate();
  const location = useLocation();

  const { refreshOrdersIn } = location.state || {};

  const triggerSummaryRefresh = () => setSummaryRefreshToken((current) => current + 1);
  const triggerOrdersRefresh = () => setOrdersRefreshToken((current) => current + 1);
  const handleSummarySliceSelect = (selection: OrdersSummaryFilterSelection) => {
    setSummaryFilterRequest((current) => ({
      ...selection,
      requestId: (current?.requestId ?? 0) + 1,
    }));
  };

  const handleRefresh = () => {
    triggerOrdersRefresh();
    triggerSummaryRefresh();
  };

  const handleExternalRefresh = () => {
    handleRefresh();
  };

  useEffect(() => {
    setSelectedRows([]);
  }, [ordersSearchBackend]);


  const orderAction = httpsCallable<Action, BaseResult>(functions, 'orderAction');



  useEffect(() => {
    if (refreshOrdersIn) {
      const timer = setTimeout(() => {
        // Action to perform after delay
        console.log('Refreshing orders...');
        handleExternalRefresh();
        // Place your code here to refresh orders or any other intended action
      }, refreshOrdersIn);

      // Clean up the timer when the component unmounts or if the value of refreshOrdersIn changes
      return () => clearTimeout(timer);
    }
  }, [refreshOrdersIn]); // Dependency array, re-run effect if refreshOrdersIn changes


  const sharedActions = <Group>

    {/* <Button c="orange" loading={approvingAll} onClick={() => {setApprovingAll(true); console.log("ey");}}>Approve all</Button> */}
    <Button
      color="yellow"
      disabled={selectedRows.length === 0}
      onClick={() => setGeneratePDFOpen(true)}
    >
      {`Generate Order forms for ${selectedRows.length} order(s)`}
    </Button>
    {/* <Button
        color="grape"
        disabled={selectedRows.length === 0}
        onClick={() => setOrderActionsOpen(true)}
      >
        {`Change Order status for ${selectedRows.length} order(s)`}
      </Button> */}

    {(userContext.msal || userClaims.kfh_oper) &&
      <Button
        color="teal"
        onClick={() => setGenerateCSVOpen(true)}
      >
        {`Generate CSV`}
      </Button>
    }

    {(userClaims.admin || userClaims.cr) &&
      <Button
        color="teal"
        onClick={() => setCollectPaymentOpen(true)}
      >
        {`Collect payment`}
      </Button>
    }
    {(userClaims.admin || userClaims.cr) &&
      <Button
        color="pink"
        onClick={() => setPaymentReminderModalOpen(true)}
      >
        {`Payment Reminder`}
      </Button>
    }
    {(userClaims.admin || userClaims.cr) &&
      <Button
        color="pink"
        onClick={() => setSendFundCertificateModalOpen(true)}
      >
        {`Send Fund Certificate`}
      </Button>
    }

  </Group>;

  const backendControls = <Group gap="sm" wrap="nowrap">
    <SegmentedControl
      value={ordersSearchBackend}
      onChange={(value) => setOrdersSearchBackend(value as OrdersSearchBackend)}
      data={[
        { label: "Firestore", value: "firestore" },
        { label: "Typesense", value: "typesense" },
      ]}
    />
    <Button
      leftSection={<BsPlusCircle />}
      onClick={() => navigate("/add_order")}
    >
      Add order
    </Button>
    <Button onClick={handleRefresh}>
      Refresh
    </Button>
  </Group>;

  const searchableOrders = ordersSearchBackend === "typesense" ? (
    <OrdersInstantSearch
      key={`typesense-${ordersRefreshToken}`}
      setSelectedRows={setSelectedRows}
      selectable={true}
      selectedRows={selectedRows}
      renderTags={true}
      navigateDetails={(obj: any) =>
        navigate("/orders/" + obj.id)
      }
      ActionsComponent={RenderActions}
      indexName={import.meta.env.VITE_TYPESENSE_ORDERS_COLLECTION!}
      summaryFilterRequest={summaryFilterRequest}
      additionalChildren={backendControls}
      topElements={sharedActions}
    />
  ) : (
    <OrdersFirestoreSearch
      setSelectedRows={setSelectedRows}
      ActionsComponent={RenderActions}
      summaryFilterRequest={summaryFilterRequest}
      refreshToken={ordersRefreshToken}
      additionalChildren={backendControls}
      topElements={sharedActions}
    />
  );

  const customerModals = useMemo(() => <>

    <GeneratePDFModal
      rows={selectedRows}
      generatingForCollection="order"
      // generatedType={"order"}
      metaTypes={Object.values(DocTypes)}
      opened={generatePDFOpen}
      getCustomerDataKey={"customerObj"}
      documentsToFetch={
        [{
          name: "orders",
          subCollectionAccessorName: "id",
          documentsToAddFunction: (orderObj: GenericProduct) => {
            // return (orderObj?.type && orderObj?.fund) ? ordersPath[orderObj?.type as SubscriptionType][orderObj.fund.id] : []
            if (!orderObj?.type || !orderObj?.fund) return [];

            let files = ordersPath[orderObj?.type as SubscriptionType][orderObj.fund.id];
            const fundsMap = globalDataContext?.fundsMap;

            if (fundsMap) {
              const orderPath = fundsMap[orderObj.fund.id]?.orders_path;
              if (orderObj?.type === "subscription") {
                files = orderPath?.subscription ?? files;
              } else if (orderObj?.type === "redemption") {
                files = orderPath?.redemption ?? files;
              }
            }

            return files;
          },
          type: "collectionGroup"

        }]
      }
      setOpened={setGeneratePDFOpen}
    />
    <CustomListActionsModal<TypesenseOrder>
      rows={selectedRows}

      opened={orderActionsOpen}
      setOpened={setOrderActionsOpen}
      availableActions={[
        {
          value: "review",
          label: "Review"
        },
        {
          value: "approve",
          label: "Approve"
        },
        {
          value: "operations_approve",
          label: "Operations Approve"
        },
      ]
      }
      handleSubmit={
        (order: TypesenseOrder, action: string, token?: string) => orderAction({ action: action as ActionType, orderID: order.id, customerID: order?.customerID, token: token! })
      }
      renderErrors={(failedOrder: TypesenseOrder) =>
        <>
          {failedOrder.customerObj?.name_en}-
          {failedOrder.units}-
          {failedOrder.fund?.name_en}

          <Space h="xl" />

        </>
      }
      getItemsData={

        (action: string) => {


          let data: TypesenseOrder[] = []


          if (action === "review")
            data = selectedRows.filter((order: TypesenseOrder) => {
              return order?.tags?.orderStatus.code === "review" || order?.tags?.orderStatus.code === "client_update"
            })


          if (action === "approve")
            data = selectedRows.filter((order: TypesenseOrder) => order?.tags?.orderStatus.code === "approval" || order?.tags?.orderStatus.code === "exec_approval")


          if (action === "operations_approve")
            data = selectedRows.filter((order: TypesenseOrder) => order?.tags?.orderStatus.code === "processing")

          return data

        }
      }
    />



    <GenerateCSVModal
      opened={generateCSVOpen}
      setOpened={setGenerateCSVOpen}
    />

    <RequestPaymentModal
      opened={collectPaymentOpen}
      setOpened={setCollectPaymentOpen}
    />

    <PaymentReminderModal
      opened={paymentReminderModalOpen}
      setOpened={setPaymentReminderModalOpen}
    />
    <SendFundCertificate
      opened={sendFundCertificateModalOpen}
      setOpened={setSendFundCertificateModalOpen}
    />


  </>,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedRows, generatePDFOpen, orderActionsOpen, generateCSVOpen, collectPaymentOpen, paymentReminderModalOpen, sendFundCertificateModalOpen])


  return (
    <>
      {showOpenEndedOrderSummary && (
        <>
          <div style={{ minWidth: 0 }}>
            <OpenEndedOrderPeriodSummary
              refreshToken={summaryRefreshToken}
              onSliceSelect={handleSummarySliceSelect}
            />
          </div>
          <Space h="xl" />
        </>
      )}
      {/* <Card shadow="sm" p="lg" radius="md" withBorder> */}
      <Card shadow="sm" p="lg" radius="md" withBorder>
        <Grid justify="space-between">
          <Grid.Col>

          </Grid.Col>
          <Grid.Col>
            {searchableOrders}
          </Grid.Col>
        </Grid>
      </Card>
      {customerModals}

      {/* </Card> */}
      {/* </Col>
            </Row> */}
    </>
  );
};


const Orders = () => {
  return (
    <main style={{ padding: "1rem 0" }}>
      <SubscriptionAndRedemptionList />

    </main>
  );
};

export default Orders;
